import { useState } from "react";
import { StepCard } from "./Bits";
import { WhopKey, Webhook, Resolution, Origins, Embed, Session, TestRun, Domain } from "./Steps";

export const Progress = ({ done, total }) => (
  <div className="flex items-center gap-4" data-testid="setup-progress">
    <div className="flex-1 h-2 bg-white/5 overflow-hidden"><div className="h-full bg-brand transition-[width] duration-700" style={{ width: `${(100 * done) / total}%` }} /></div>
    <span className="font-mono text-sm text-brand tabular-nums">{done}/{total}</span>
  </div>
);

export const Wizard = ({ d, edit, setD, reload }) => {
  const firstOpen = d.steps.find((s) => !s.done && !s.optional)?.id;
  const [open, setOpen] = useState(firstOpen ? { [firstOpen]: true } : {});
  const v = d.values;
  const body = {
    whop_key: <WhopKey edit={edit} onSaved={setD} reload={reload} />, webhook: <Webhook v={v} edit={edit} onSaved={setD} />,
    resolution: <Resolution edit={edit} reload={reload} />, origins: <Origins v={v} edit={edit} reload={reload} />,
    embed: <Embed v={v} edit={edit} reload={reload} />, domain: <Domain v={v} edit={edit} reload={reload} />, session: <Session edit={edit} reload={reload} />, test: <TestRun />,
  };
  return (
    <div className="space-y-3" data-testid="setup-wizard">
      {d.steps.map((s, i) => (
        <StepCard key={s.id} n={i + 1} step={s} optional={s.optional} open={!!open[s.id]} toggle={() => setOpen((o) => ({ ...o, [s.id]: !o[s.id] }))}>
          {body[s.id]}
        </StepCard>
      ))}
    </div>
  );
};
